import { Controller } from '@hotwired/stimulus'

// Форма конструктора турниров: при смене числа игроков/пар перестраивает
// строки имён и кортов (introduced значения сохраняются), для round robin
// пересчитывает жёстко заданное число раундов (пары - 1).
export default class TournamentFormController extends Controller {
  static targets = [
    'count',
    'rounds',
    'hint',
    'playerRows',
    'menRows',
    'womenRows',
    'courtRows'
  ]
  static values = {
    mode: String, // players | mix | team
    playerPlaceholder: String,
    manPlaceholder: String,
    womanPlaceholder: String,
    courtPlaceholder: String,
    roundRobin: Boolean,
    roundsHint: String
  }

  rebuild() {
    const players = parseInt(this.countTarget.value, 10)

    if (this.modeValue === 'mix') {
      this.renderInputs(
        this.menRowsTarget,
        players / 2,
        'user_tournament[men_names][]',
        this.manPlaceholderValue
      )
      this.renderInputs(
        this.womenRowsTarget,
        players / 2,
        'user_tournament[women_names][]',
        this.womanPlaceholderValue
      )
    } else if (this.modeValue === 'team') {
      this.renderPairRows(players / 2)
    } else {
      this.renderNumberedRows(
        this.playerRowsTarget,
        players,
        'user_tournament[player_names][]',
        this.playerPlaceholderValue
      )
    }

    this.renderInputs(
      this.courtRowsTarget,
      Math.floor(players / 4),
      'user_tournament[court_names][]',
      this.courtPlaceholderValue
    )

    if (this.roundRobinValue && this.hasRoundsTarget) {
      const rounds = players / 2 - 1
      this.roundsTarget.innerHTML = `<option value="${rounds}" selected>${rounds}</option>`
    }
  }

  renderInputs(container, count, name, placeholder) {
    const existing = [...container.querySelectorAll('input')].map(
      (i) => i.value
    )
    container.innerHTML = ''
    for (let i = 0; i < count; i++) {
      container.appendChild(
        this.buildInput(name, placeholder.replace('%{n}', i + 1), existing[i])
      )
    }
  }

  renderNumberedRows(container, count, name, placeholder) {
    const existing = [...container.querySelectorAll('input')].map(
      (i) => i.value
    )
    container.innerHTML = ''
    for (let i = 0; i < count; i++) {
      const row = document.createElement('div')
      row.className = 'flex items-center gap-2'
      row.appendChild(this.buildIndex(i + 1))
      row.appendChild(
        this.buildInput(
          name,
          placeholder.replace('%{n}', i + 1),
          existing[i],
          'flex-1'
        )
      )
      container.appendChild(row)
    }
  }

  renderPairRows(pairs) {
    const container = this.playerRowsTarget
    const existing = [...container.querySelectorAll('input')].map(
      (i) => i.value
    )
    container.innerHTML = ''
    for (let i = 0; i < pairs; i++) {
      const row = document.createElement('div')
      row.className = 'flex items-center gap-2'
      row.appendChild(this.buildIndex(i + 1))
      row.appendChild(
        this.buildInput(
          'user_tournament[player_names][]',
          this.playerPlaceholderValue.replace('%{n}', i * 2 + 1),
          existing[i * 2],
          'flex-1'
        )
      )
      row.appendChild(
        this.buildInput(
          'user_tournament[player_names][]',
          this.playerPlaceholderValue.replace('%{n}', i * 2 + 2),
          existing[i * 2 + 1],
          'flex-1'
        )
      )
      container.appendChild(row)
    }
  }

  buildIndex(number) {
    const index = document.createElement('span')
    index.className = 'w-6 text-sm text-text-tertiary'
    index.textContent = `${number}.`
    return index
  }

  buildInput(name, placeholder, value, extraClass = '') {
    const input = document.createElement('input')
    input.type = 'text'
    input.name = name
    input.maxLength = 30
    input.placeholder = placeholder
    input.className = `tournament-name-input ${extraClass}`.trim()
    if (value) input.value = value
    return input
  }
}
